export default {
  loadTypes: {
    furniture: 'اسباب کشی',
    cargo: 'بار سنگین',
    postalPostage: 'مرسوله پستی',
    delivery: 'پیک',
    pickup: 'بار شهری (وانت)',
    material: 'مصالح',
    trash: 'نخاله',
    freight: 'پیک'
  },
  pending: 'در انتظار تایید',
  accepted: 'تایید شده',
  current: 'جاری',
  completed: 'تکمیل شده',
  canceled: 'لغو شده',
  chooseCourier: 'انتخاب باربری',
  chooseDriver: 'انتخاب راننده',
  loadType: 'نوع بار',
  templateType: 'نوع الگو',
  origin: 'مبدا',
  destination: 'مقصد',
  multiDestination: 'چند مقصدی',
  payableAmount: 'قابل پرداخت',
  cancelRequest: 'لغو درخواست',
  reOrderRegistration: 'ثبت سفارش مجدد',
  submitFeedback: 'ثبت بازخورد',
  editFeedback: 'ویرایش بازخورد',
  useTemplate: 'استفاده از الگو',
  addNewTemplate: 'افزودن الگوی جدید',
  createTemplate: 'ایجاد الگو',
  driverLiveLocation: 'موقعیت راننده',
  notPriced: 'قیمت تعیین نشده',
  generalInfo: 'اطلاعات کلی',
  loadTime: 'زمان بارگیری',
  loadTimeHour: 'ساعت بارگیری',
  dischargeTime: 'زمان تخلیه',
  estimatedTimeFromOriginToDestination: 'زمان تقریبی مبدا تا مقصد',
  distanceFromOriginToDestination: 'فاصله مبدا تا مقصد',
  driverOfferAmount: 'مبلغ پیشنهادی راننده',
  driverName: 'نام راننده',
  driverLastName: 'نام خانوادگی راننده',
  driverNationalId: 'کد ملی راننده',
  smartFleetCode: 'کد هوشمند ناوگان',
  plate: 'پلاک',
  originAndDestinationInfo: 'اطلاعات مبدا و مقصد',
  deliverer: 'تحویل دهنده',
  transferee: 'تحویل گیرنده',
  floor: 'طبقه',
  unit: 'واحد',
  distanceFromDoorToCar: 'فاصله درب تا خودرو',
  destination1: 'مقصد اول',
  destination2: 'مقصد دوم',
  destination3: 'مقصد سوم',
  destination4: 'مقصد چهارم',
  finalDestination: 'مقصد نهایی',
  trackingCodeOfCourier: 'کد رهگیری {courier}',
  orderTracking: 'رهگیری سفارش',
  carType: 'نوع خودرو',
  loaderType: 'نوع بارگیر',
  numberOfWorkers: 'تعداد کارگر',
  trajectory: 'خط سیر',
  noAllocation: 'عدم تخصیص',
  loadSpecifications: 'مشخصات بار',
  packageType: 'نوع بسته بندی',
  weight: 'وزن',
  loadMonetaryValue: 'ارزش بار',
  monetaryValue: 'ارزش',
  technicalForce: 'نیروی فنی',
  costlyItems: 'اقلام هزینه دار',
  stop: 'توقف',
  returnToOrigin: 'بازگشت به مبدا',
  postalPostageSpecifications: 'مشخصات مرسوله پستی',
  contents: 'محتویات',
  collectionTime: 'زمان جمع آوری',
  totalAmount: 'مبلغ کل',
  discount: 'تخفیف',
  templateTitle: 'عنوان الگو',
  continueOrderRegistration: 'ادامه ثبت سفارش',
  movingDate: 'تاریخ اسباب کشی',
  movingTime: 'ساعت اسباب کشی',
  loadDate: 'تاریخ بارگیری',
  dischargeDate: 'تاریخ تخلیه',
  loadTemplate: 'الگوی سفارش',
  loadDraft: 'پیش نویس بار',
  middlePoints: {
    1: 'مقصد اول',
    2: 'مقصد دوم',
    3: 'مقصد سوم',
    4: 'مقصد چهارم',
    5: 'مقصد پنجم'
  },
  completeAddress: 'تکمیل آدرس',
  freightElevator: 'آسانسور حمل بار',
  withCar: 'با خودرو',
  withoutCar: 'بدون خودرو',
  theSelectedCarWasRemoved: 'خودرو انتخابی حذف شد',
  removeSimpleEmployeeForChangeState:
    'برای تغییر نوع {orderType}، لطفا کارگر(های) حمل بار انتخاب شده را از لیست خود حذف کنید.',
  removeCarsForChangeState:
    'برای تغییر نوع {orderType}، لطفا خودرو(های) انتخاب شده را از لیست خود حذف کنید.',
  removePackagesForChangeState:
    'برای تغییر نوع {orderType}، لطفا بسته(های) انتخاب شده را از لیست خود حذف کنید.',
  timing: 'تاریخ و زمان',
  carLaborerCount: 'تعداد کارگر {carTitle} {number}',
  cargoWorker: 'کارگر حمل بار',
  intercityCarSelectionDescription:
    'کارگران حمل بار در شهر مقصد به عهده صاحب بار میباشد.',
  sortBy: 'مرتب سازی بر اساس',
  sortOptions: {
    popular: 'محبوب‌ترین',
    name: 'نام',
    cheapest: 'ارزان‌ترین',
    mostExpensive: 'گران‌ترین',
    nearest: 'نزدیک‌ترین'
  },
  distance: 'فاصله',
  courierProfile: 'پروفایل باربری',
  offerSelectionError: {
    singleSelect: 'برای ادامه یک باربری را انتخاب کنید',
    multiSelect: 'برای ادامه حداقل یک باربری را انتخاب کنید'
  },
  completeInformation: 'تکمیل اطلاعات',
  saveAsDraft: 'ذخیره به عنوان پیشنویس',
  editLoadTemplate: 'ویرایش الگوی سفارش',
  submitLoadTemplate: 'ثبت الگوی سفارش',
  submitAndPay: 'ثبت و پرداخت',
  submitRequest: 'ثبت درخواست',
  createOrderWarning:
    'پس از ثبت سفارش، امکان تغییر باربری وجود ندارد.\nاز ثبت سفارش اطمینان دارید؟',
  tariffBasedLoadSuccessDescription:
    'درخواست حمل شما با موفقیت ثبت گردید، به محض قبول درخواست توسط یکی از باربری‌ها، پیامک تأیید برای شما ارسال می‌گردد.',
  notTariffBasedLoadSuccessDescription:
    'درخواست حمل شما با موفقیت ثبت گردید، به محض اعلام قیمت توسط هر باربری، پیامک اطلاع رسانی برای شما ارسال می‌گردد.',
  viewSubmittedLoads: 'مشاهده سفارش‌های ثبت شده',
  submitNewLoadRequest: 'درخواست حمل جدید',
  busyCities: 'شهرهای پرتردد',
  selectPointOnMap: 'انتخاب {point} روی نقشه',
  more: 'بیشتر ...',
  rangeMessage: {
    100: 'این درخواست با تعرفه ی <b>شهری</b> محاسبه خواهد شد',
    200: 'این درخواست با قوانین و تعرفه <b>بین شهری</b> محاسبه خواهد شد'
  },
  pleaseSelectPointOnMap: 'لطفا {item} را از روی نقشه انتخاب کنید',
  loadWeight: 'وزن بار',
  typeOfShippingDocument: 'نوع سند حمل',
  postageSpecification: 'مشخصات مرسوله',
  postage: 'مرسوله',
  addPostage: 'افزودن مرسوله',
  selectCollectionTImeToContinue:
    'برای ادامه، زمان جمع آوری کالا را انتخاب کنید',
  loadId: 'شناسه سفارش',
  specification: 'مشخصات',
  newLoadTemplateCreatedSuccessfully: 'الگوی سفارش جدید با موفقیت ایجاد شد',
  areYouSureYouWantToDraftThisOrder:
    'آیا از ذخیره این سفارش به عنوان پیش نویس اطمینان دارید؟',
  draftCreatedSuccessfully: 'پیش نویس سفارش با موفقیت ایجاد شد',
  selectDriverInfo: 'انتخاب اطلاعات راننده',
  selectVehicleInfo: 'انتخاب اطلاعات خودرو',
  selectLocation: 'انتخاب محل',
  propertySelection: 'تعیین ویژگی ها',
  offerSelection: 'انتخاب پیشنهادات (باربری)',
  overview: 'بررسی اجمالی',
  successfulSubmit: 'ثبت موفقیت آمیز',
  orderCancelReason: 'دلیل لغو سفارش',
  orderCanceledSuccessfully: 'سفارش با موفقیت لغو شد',
  courierSelectedSuccessfullyForThisOrder:
    'باربری {courier} با موفقیت برای این سفارش انتخاب شد',
  driverSelectedSuccessfullyForThisOrder:
    'راننده {driver} با موفقیت برای این سفارش انتخاب شد',
  loadTemplateEditedSuccessfully: 'الگوی سفارش با موفقیت ویرایش شد',
  selectCity: 'انتخاب شهر',
  citySelectorDescription_html:
    'لطفا یکی از شهر های زیر را به عنوان <span class="font-bold">{title}</span> انتخاب کنید',
  submitAndNextStep: 'تایید و مرحله بعد',
  temporaryLoadSuccessMessage:
    'درخواست حمل شما با موفقیت ثبت گردید، به محض قبول درخواست توسط راننده، پیامک تأیید برای شما ارسال می‌گردد.',
  reserveOrderForLater: 'رزرو درخواست برای آینده',
  reserveDate: 'تاریخ رزرو',
  reserveTime: 'ساعت رزرو',
  doYouWantToSaveUncompletedOrderToDrafts:
    'آیا میخواهید سفارش ناتمام را در پیش نویس ذخیره کنید؟',
  orderPresubmitedInSystemAndSubmitWhenPaymentIsDone:
    'درخواست شما در باربانت ثبت و پس از پرداخت موفق در سیستم {thirdParty} ثبت می‌شود.',
  orderStatus: 'وضعیت درخواست',
  moveToMiddlePoint: 'حرکت به سمت {middlePoint}',
  paid: 'پرداخت شده',
  notPaid: 'پرداخت نشده',
  addDestination: 'افزودن مقصد',
  viewOnMap: 'مشاهده روی نقشه',
  deliveryCode: 'کد تحویل',
  dateOfCollection: 'تاریخ جمع‌آوری',
  timeOfCollection: 'ساعت جمع‌آوری',
  gatheringLocation: 'محل جمع‌آوری',
  dischargeLocation: 'محل تخلیه',
  carExcluded: 'بدون ماشین',
  insuranceExcessPercent: 'درصد افزایش بیمه',
  manualExcessPercent: 'درصد افزایش دستی',
  excelFileInfo: 'اطلاعات فایل اکسل',
  grouping: 'گروه بندی',
  groupingDescription:
    'برای گروه‌ ارسالی جدید،نوع وسیله نقلیه و  راننده انتخاب کنید. ',
  submitLoads: 'ثبت بار ها',
  loads: 'بار ها',
  allLoadDatesInGroupShouldBeInSameDay:
    'تاریخ بارگیری همه آیتم های گروه باید در یک روز باشند!',
  allLoadTypesInGroupShouldBeTheSame:
    'نوع بار همه آیتم های گروه باید یکسان باشد!',
  allPackageTypesInGroupShouldBeTheSame:
    'نوع بسته‌بندی همه آیتم های گروه باید یکسان باشد!',
  dischargeStartTime: 'زمان شروع تخلیه',
  dischargeEndTime: 'زمان پایان تخلیه',
  dischargeEndTimeShouldBeAtLeastOneHourAfterStartTime:
    'زمان پایان تخلیه باید حداقل یک ساعت بعد از زمان شروع تخلیه باشد!',
  loadingStartTime: 'زمان شروع بارگیری',
  loadingEndTime: 'زمان پایان بارگیری',
  addon: 'خدمات جانبی',
  destinations: {
    1: 'مقصد اول',
    2: 'مقصد دوم',
    3: 'مقصد سوم',
    4: 'مقصد چهارم',
    5: 'مقصد پنجم',
    6: 'مقصد ششم',
    7: 'مقصد هفتم',
    8: 'مقصد هشتم',
    9: 'مقصد نهم',
    10: 'مقصد دهم'
  },
  licenseIsRequired: 'مجوز نیاز است',
  licenses: 'مجوز ها',
  IWantInsurance: 'بیمه می‌خواهم',
  fromStartToEnd: 'از ساعت {start} تا ساعت {end}',
  nameOfThePayee: 'نام متولی پرداخت'
}
